<template>
  <b-modal 
    id="modalTermos" 
    :title="$t('Termos_de_Servico')" 
    hide-footer 
    modal-class="modal-terms"
    size="xl"
    scrollable
  >
    
    <!-- ======================================= -->
    <!-- CASO 1: Laboratório BR com termo TEXTO -->
    <!-- ======================================= -->
    <div 
      v-if="termo && termo.tipo_termo === 'texto'" 
      class="termos-content"
      style="max-height: 500px; overflow-y: auto;"
    >
      <h4>{{ termo.titulo }}</h4>
      <div v-html="termo.conteudo" class="termo-html-content"></div>
    </div>

    <!-- ====================================== -->
    <!-- CASO 2: Laboratório BR com termo PDF -->
    <!-- ====================================== -->
    <div 
      v-else-if="termo && termo.tipo_termo === 'pdf'" 
      class="pdf-container"
    >
      <h4 class="mb-3">{{ termo.titulo }}</h4>
      
      <!-- Iframe para visualizar PDF -->
      <iframe
        v-if="termo.pdfViewUrl"
        :src="termo.pdfViewUrl"
        class="pdf-viewer"
        frameborder="0"
      />
      
      <!-- Botão para abrir em nova aba -->
      <div class="text-center mt-2">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="abrirPdfNovaAba"
        >
          <feather-icon icon="ExternalLinkIcon"/>
          {{ $t('Abrir_PDF_nova_aba') }}
        </b-button>
      </div>
    </div>

    <!-- ====================================== -->
    <!-- CASO 3: Laboratório US (termo fixo) -->
    <!-- ====================================== -->
    <!-- <div 
      v-else-if="getPais === 'US'" 
      class="termos-content" 
      style="max-height: 500px; overflow-y: auto;"
    >
      <h4>{{ $t('Termos_de_Servico') }} - {{ nomeLaboratorio }}</h4>
      
      <div v-if="cliente && cliente.configuracoes && cliente.configuracoes.termos_servico"
           v-html="cliente.configuracoes.termos_servico">
      </div>
      <div v-else>
        <p>{{ $t('termo_1') }}</p>
        <p>
          {{ $t('termo_2') }}
          <strong>{{ $t('taxa_cancelamento') }}</strong> 
          {{ $t('termo_3') }}
        </p>
        <p>
          {{ $t('termo_4') }}
          <span style="font-weight: bold; color: #2c3e50;">{{ nomeLaboratorio }}</span>
          {{ $t('termo_5') }}
          <span style="font-weight: bold; color: #2c3e50;">{{ nomeLaboratorio }}</span>
          {{ $t('termo_6') }}
          <span style="font-weight: bold; color: #2c3e50;">{{ nomeLaboratorio }}</span> 
          {{ $t('termo_7') }}
        </p>
        <p>{{ $t('termo_8') }}</p>
      </div>
    </div> -->

    <!-- ====================================== -->
    <!-- CASO 4: Sem termo (fallback) -->
    <!-- ====================================== -->
    <div 
      v-else 
      class="termos-content"
    >
      <b-alert variant="info" show>
        {{ $t('Este_laboratorio_ainda_nao_cadastrou_termos') }}
      </b-alert>
    </div>

    <!-- ====================================== -->
    <!-- ÁREA DE ACEITE (COMUM A TODOS) -->
    <!-- ====================================== -->
    
    <hr>

    <!-- Alerta de sucesso quando aceitar -->
    <b-alert v-if="permitirConcordar" variant="success" show>
      {{ $t('Você_leu_todos_os_termos_e_Concordou') }}
    </b-alert>

    <!-- Info sobre assinatura digital (se requerida) -->
    <b-alert 
      v-if="termo && termo.requer_assinatura && !permitirConcordar" 
      variant="info" 
      show
    >
      <feather-icon icon="InfoIcon"/>
      {{ $t('Este_laboratorio_tambem_exige_assinatura_digital') }}
    </b-alert>

    <!-- Botões de Ação -->
    <div class="d-flex justify-content-end mt-3">
      <b-button
        variant="success"
        @click="concordar"
        :disabled="aceitou"
      >
        {{ aceitou ? $t('Você_ja_concordou') : $t('Concordo') }}
      </b-button>
      
      <b-button
        variant="primary"
        @click="$bvModal.hide('modalTermos')" 
        class="ml-2"
      >
        {{ $t('Fechar') }}
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { BModal, BButton, BAlert } from 'bootstrap-vue'

export default {
  name: 'ModalTermosServico',
  
  components: {
    BModal,
    BButton,
    BAlert
  },
  
  props: {
    nomeLaboratorio: {
      type: String,
      default: ''
    },
    permitirConcordar: {
      type: Boolean,
      default: false
    },
    termo: {
      type: Object,
      default: null
    }
  },
  
  data() {
    return {
      localPermitirConcordar: this.permitirConcordar
    };
  },

  computed: {
    ...mapState({
      cliente: state => state.tabelas.clienteConfig
    }),
    ...mapGetters('laboratorios', ['getPais']),

    aceitou() {
      return this.permitirConcordar
    }
  },

  watch: {
    permitirConcordar(newVal) {
      this.localPermitirConcordar = newVal;
    }
  },

  methods: {
    concordar() {
      this.localPermitirConcordar = true;
      this.$emit('termosAceitos', true);
      this.$bvModal.hide('modalTermos')
    },
    
    abrirPdfNovaAba() {
      if (this.termo && this.termo.pdfViewUrl) {
        window.open(this.termo.pdfViewUrl, '_blank');
      }
    }
  }
}
</script>

<style scoped>
.termos-content {
  padding: 15px;
  line-height: 1.6;
}

.termo-html-content {
  font-size: 14px;
}

.termo-html-content >>> h1,
.termo-html-content >>> h2,
.termo-html-content >>> h3 {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.termo-html-content >>> p {
  margin-bottom: 1rem;
}

.termo-html-content >>> ul,
.termo-html-content >>> ol {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

.pdf-container {
  width: 100%;
}

.pdf-viewer {
  width: 100%;
  height: 600px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

@media (max-width: 768px) {
  .pdf-viewer {
    height: 400px;
  }
}
</style>